export class getgridBO {

  agencyID: string | null;
  currentpageno: number = 1;
  pageitem: number = 10;
  OnboardStatusLid: any;
  searchText: string;
  orderColumn: string = "officeNote";
  orderType: string = "asc";
  type: string = "string";
  field: string = "officeNote";
  operator: string = "startswith";
  value: string = "";
  matchCase: boolean = false;
}

export class employeeFilter {
  employeeType: string;
  employeeStatus: string;
}


export class ColumnChangeBO {
  id: string;
  userid: string | null;
  agencyId: string | null;
  column: string;
}
// export class EmployeeofficeBO{
//   notes:any
//   requestId:any
// }

export class officeNotesBO {
  profileId: string;
  officeNotes: string;
}


export class employeeOnboardEmit {
  isView: boolean;
  isEdit: boolean;
  isNew: boolean
  isEditDocument: boolean;
  disableDoc: boolean;
  employeeToDocument: boolean = false;
  employeeId: string;
  agencyId: string;
  status: any;
}


export class EmployeeAgreementDocumentAgencyBO {
  id: string;
  employerstatus: string = "00000000-0000-0000-0000-000000000000";
  employeestatus: string = "00000000-0000-0000-0000-000000000000";
  completed: string = "00000000-0000-0000-0000-000000000000";
  agencyId: string;
  officenotes: string;
  clientName: string;
  currentpageno: number = 1;
  pageitem: number = 10;
  OnboardStatusLid: any;
  searchText: string;
  orderColumn: string = "employerName";
  orderType: string = "asc";
  type: string = "string";
  field: string = "employerName";
  operator: string = "startswith";
  value: string = "";
  matchCase: boolean = false;
  employeeid: string;
  clientId: string;
  isCompleted: boolean;
  employerstatusLid: string | null;
  employeestatusLid: string | null;
  status: string;
  employerName: string;

}

export class PayNoticePayrateDetailBO {
  id: string = "00000000-0000-0000-0000-000000000000";
  effectiveDate: string;
  service: string;
  rate: number;
  payNoticeId: string;
  agencyId: string;
}
// export class EmployeeAgreementDocumentAgencyBO   {
//   id: string;
//   clientId: string;
//   employeeid: string;
//   employerstatus: string;
//   employeestatus: string;
//   isCompleted: boolean;
//   agencyId: string;
//   officenotes: string;
//   clientName: string;
//   employerstatusLid: string;
//   employeestatusLid: string;
//   completed: boolean;
// }







export class EmployeeDocumentBO {

  orderColumn: string = "statusName";
  orderType: string = "asc";
  type: string = "string";
  field: string = "statusName";
  operator: string = "startswith";
  value: string = "";
  matchCase: boolean = false;
  pageitem: number = 10;
  currentpageno: number = 1;
  status: string = "00000000-0000-0000-0000-000000000000";
  completed: string = "00000000-0000-0000-0000-000000000000";
  employeeId: string;
  employerId: string;
  agencyId: string;


}


export class EmployeeOfficeNotesBO {
  documentLid: string;
  officenotes: string;
  agencyId: string;
}

export class RelationshipDisclosureTaxDetailBO {
  id: string = "00000000-0000-0000-0000-000000000000";
  taxName: string;
  taxable: boolean;
  relationshipDisclosureId: string;
}


